import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CandidateTypes } from "@/Components/common/client/candidates/CandidateTypes";
import { InvitedList } from "@/Components/common/client/candidates/Listing/InvitedList";
import BulkInviteCandidateModal from "@/Components/modals/client/BulkInviteCandidateModal";
import CheckInvitedCandidateTypeModal from "@/Components/modals/client/CheckInvitedCandidateTypeModal";
import InviteCandidateModal from "@/Components/modals/client/InviteCandidateModal";
import {
  fetchInvitedCandidates,
  setInvitedCandidatesLoading,
  updateSelectedCandidate,
  updatePagination,
} from "@/reducers/client_candidates/candidatesinvited";
import { updateactivePages } from "@/reducers/clientcommon";
import useTitle from "@/utilities/hooks/useTitle";
/**
 * Renders the Invited component.
 *
 * @return {JSX.Element} the rendered Invited component
 */
const Invited = () => {
  useTitle("Invited Candidates");
  const { filters, pagination } = useSelector(
    (state) => state.clientCandidatesInvited,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setInvitedCandidatesLoading(true));
    dispatch(fetchInvitedCandidates());
    dispatch(
      updateactivePages({
        activePage: "candidates",
        activeSubPage: "invited",
      }),
    );
    dispatch(updateSelectedCandidate([]));
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <CandidateTypes />
      <InvitedList />
      <InviteCandidateModal />
      <BulkInviteCandidateModal />
      <CheckInvitedCandidateTypeModal />
    </div>
  );
};

export default Invited;
